<template>
  <div class="app-accordion">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppAccordion'
}
</script>

<style lang="scss" scoped>
.app-accordion {
  border: 1px solid map-get($color-util, 'light');
  border-radius: 0.5rem;
}
</style>
